import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { MENUS } from '../../_models/configuration.model';
import { ConfigurationService } from '../configuration/configuration.service';

/** Destino si falta permiso: el primer menú visible o "sin acceso". */
export const primeraRuta = (menus: readonly string[]) => MENUS.find(m => menus.includes(m.id))?.ruta ?? '/unauthorized';

/** Entra si el usuario ve alguno de esos menús; si no, va al primero que ve. */
export const verMenu = (...ids: readonly string[]): CanMatchFn => () => {
  const router = inject(Router);
  return inject(ConfigurationService).misMenus$.pipe(first(), map(m => ids.some(id => m.includes(id)) || router.parseUrl(primeraRuta(m))));
};
